import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import "../../variables.css";
import "../../index.css";
import * as XLSX from 'xlsx';

const ExportToExcel = ({ excelRows, excelColumns, excelName, fontSize, styleObj }) => {
    const downloadExcel = () => {
        const worksheet = XLSX.utils.aoa_to_sheet([
            excelRows,
            ...excelColumns
        ]);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, excelName);

        XLSX.writeFile(workbook, `${excelName}.xlsx`);
    };

    return (
        <CloudDownloadIcon className="cursor-pointer export-icon-color" style={ styleObj} onClick={ downloadExcel } fontSize={ fontSize || "medium" }></CloudDownloadIcon>
    )
}

export default ExportToExcel;